import React from 'react';
import { Link } from 'react-router-dom';
import classnames from 'classnames';
import styles from './createSearchButton.module.scss';

interface ActiveSearchBtnProps {
  label: string;
  link: string;
  asButton?: boolean;
  disabled?: boolean;
  onClickHandler?: () => void;
}

export const ActiveSearchButton = ({
  label,
  link,
  asButton = false,
  disabled = false,
  onClickHandler = void 0,
}: ActiveSearchBtnProps) => {
  const dataCy = label.replace(/\s/g, '');

  return !asButton ? (
    <Link
      to={disabled ? '#' : link}
      className={classnames('btn btn-primary', styles.createSearchBtn, {
        disabled,
      })}
      data-cy={`${dataCy}:${dataCy}-button`}
    >
      {label}
    </Link>
  ) : (
    <button
      className={classnames('btn btn-primary', styles.createSearchBtn)}
      onClick={onClickHandler}
      disabled={disabled}
    >
      {label}
    </button>
  );
};
